export default __webpack_public_path__ + "static/media/Group 35385.93fb0a62.png";